import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'react-toastify';


const API_URL = process.env.REACT_APP_API_URL;

const AddMarketplace = () => {
  const { productId } = useParams(); // Product ID from URL
  const [marketplaces, setMarketplaces] = useState([]);
  const [selectedMarketplaces, setSelectedMarketplaces] = useState({});
  const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
  
  const [product, setProduct] = useState(null); // Store the product details
console.log(product,"productproductproduct");

  // Fetch product details by ID
  const fetchProduct = async () => {
    try {
      const response = await axios.get(`${API_URL}/products/getProduct/${productId}`);
      setProduct(response.data.data.product);
      
      // Pre-populate selected marketplaces
      const initialSelectedMarketplaces = {};
      response.data.data.product.marketplaces.forEach((marketplace) => {
        initialSelectedMarketplaces[marketplace.marketplaceId._id] = {
          price: marketplace.price,
          url: marketplace.url,
        };
      });
      setSelectedMarketplaces(initialSelectedMarketplaces);
    } catch (error) {
      console.error('Failed to fetch product:', error);
      toast.error('Failed to load product');
    }
  };

  // Fetch all marketplaces
  const fetchMarketplaces = async () => {
    try {
      const response = await axios.get(`${API_URL}/marketplace/getAllMarketplaces`);
      setMarketplaces(response?.data || []); // Fix here
    } catch (error) {
      console.error('Failed to fetch marketplaces:', error);
      toast.error('Failed to load marketplaces');
    }
  };

  // Fetch both product and marketplaces on component mount
  useEffect(() => {
    fetchProduct();
    fetchMarketplaces();
  }, []);

  const handleSelectMarketplace = (marketplaceId) => {
    setSelectedMarketplaces((prev) => {
      const updated = { ...prev };
      if (updated[marketplaceId]) {
        delete updated[marketplaceId];
      } else {
        updated[marketplaceId] = { price: '', url: '' };
      }
      return updated;
    });
  };

  const handleInputChange = (marketplaceId, field, value) => {
    setSelectedMarketplaces((prev) => ({
      ...prev,
      [marketplaceId]: {
        ...prev[marketplaceId],
        [field]: value,
      },
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const marketplacesData = Object.entries(selectedMarketplaces).map(([marketplaceId, data]) => ({
      marketplaceId,
      price: Number(data.price),
      url: data.url,
    }));

    if (marketplacesData.length === 0) {
      toast.warning('Select at least one marketplace');
      return;
    }

    try {
      setLoading(true);
      await axios.put(`${API_URL}/products/updateProduct/${productId}`, {
        marketplaces: marketplacesData,
      });
      toast.success('Marketplaces updated successfully!');
      navigate("/products")
    } catch (error) {
      console.error('Failed to update product:', error);
      toast.error('Failed to update product');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="p-6 max-w-4xl mx-auto">
      <h1 className="text-3xl font-bold mb-6">Update Marketplaces</h1>
      <div className="flex items-center justify-between mb-2">
      <p className="text-lg font-semibold text-gray-800 hover:text-orange-500 transition duration-350 transform hover:scale-105 cursor-pointer">
  {product?.title}
</p>

      <div className="flex justify-end mb-1">
    <a
      href={`https://solarstation.in/product/${product?.slug}`}
      rel="noopener noreferrer"
      className="font-semibold py-2 px-6 rounded bg-slate-700 text-white  hover:bg-slate-800 transition-colors"
>
      Visit Marketplace
    </a>
    </div>
  </div>
      <form onSubmit={handleSubmit}>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {marketplaces.map((marketplace) => (
            <div key={marketplace._id} className="border p-4 rounded-md shadow-sm">
              <label className="flex items-center gap-3 mb-2">
                <input
                  type="checkbox"
                  checked={selectedMarketplaces.hasOwnProperty(marketplace._id)}
                  onChange={() => handleSelectMarketplace(marketplace._id)}
                />
                <img
                  src={marketplace.icon}
                  alt={marketplace.name}
                  className="w-10 h-10 object-contain"
                />
                <span className="font-semibold">{marketplace.name}</span>
              </label>

              {selectedMarketplaces[marketplace._id] && (
                <div className="space-y-3 mt-3">
                  <input
                    type="text"
                    placeholder="Marketplace URL"
                    className="w-full border rounded px-3 py-2"
                    value={selectedMarketplaces[marketplace._id].url}
                    onChange={(e) => handleInputChange(marketplace._id, 'url', e.target.value)}
                    required
                  />
                  <input
                    type="number"
                    placeholder="Price"
                    className="w-full border rounded px-3 py-2"
                    value={selectedMarketplaces[marketplace._id].price}
                    onChange={(e) => handleInputChange(marketplace._id, 'price', e.target.value)}
                    required
                  />
                </div>
              )}
            </div>
          ))}
        </div>

        <button
          type="submit"
          disabled={loading}
          className="mt-6 bg-slate-700 hover:bg-slate-800 text-white font-semibold py-2 px-6 rounded"
        >
          {loading ? 'Updating...' : 'Update Product'}
        </button>
      </form>
    </div>
  );
};

export default AddMarketplace;
